import React from "react";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";

const Home = () => {
  return (
    <div>
      <Carousel />
      <div
        style={{ display: "flex", justifyContent: "end", marginBottom: "20px" }}
      >
        <button
          style={{
            backgroundColor: "black",
            borderRadius: "8px",
            padding: "5px 10px",
            fontSize: "16px",
          }}
        >
          <Link to="/aboutus" style={{ color: "white" }}>
            Read More...
          </Link>
        </button>
      </div>
    </div>
  );
};

export default Home;
